<template>
  <v-card flat>
    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="body-2">{{ labels.mainDetail }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap xs12>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Claim No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span class="title">{{ commonInfo.clmNo }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Status</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span :class="formatStatusCode(commonInfo.clmStat)">{{ commonInfo.clmStatDesc }}</span> - {{ formatDate(commonInfo.statDate) }}
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Loss Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDisplayDateTime2(commonInfo.lossDate) }}</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Notification Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ formatDate(commonInfo.notDate) }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.polNo">
                  <v-subheader class="queryLabel">Policy No.</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.polNo">
                  <span class="title">{{ commonInfo.polNo }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.renCnt || commonInfo.renCnt === 0">
                  <v-subheader class="queryLabel">Renewal</v-subheader>
                </v-flex>
                <v-flex xs2 v-if="commonInfo.renCnt || commonInfo.renCnt === 0">
                  <span>{{ commonInfo.renCnt }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.endtCnt || commonInfo.endtCnt === 0">
                  <v-subheader class="queryLabel">Endorsement</v-subheader>
                </v-flex>
                <v-flex xs2 v-if="commonInfo.endtCnt || commonInfo.endtCnt === 0">
                  <span>{{ commonInfo.endtCnt }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.comDate">
                  <v-subheader class="queryLabel">Period of Cover</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.comDate && commonInfo.expDate">
                  <span>{{ formatDate(commonInfo.comDate) }} - {{ formatDate(commonInfo.expDate) }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.uwYr">
                  <v-subheader class="queryLabel">Underwriting Year</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.uwYr">
                  <span>{{ commonInfo.uwYr }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.dri">
                  <v-subheader class="queryLabel">Direct / RI Inwards</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.dri">
                  <span>{{ commonInfo.dri }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.polType">
                  <v-subheader class="queryLabel">Policy Type</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.polType">
                  <span>{{ commonInfo.polType }} - {{ commonInfo.polTypeDesc }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.cty">
                  <v-subheader class="queryLabel">Country</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.cty">
                  <span>{{ commonInfo.ctyDesc }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.fund">
                  <v-subheader class="queryLabel">Fund</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.fund">
                  <span>{{ commonInfo.fundDesc }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.branch">
                  <v-subheader class="queryLabel">Branch</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.branch">
                  <span>{{ commonInfo.branch }} - {{ commonInfo.branchDesc }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.acctNo1">
                  <v-subheader class="queryLabel">Billing Account</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.acctNo1">
                  <span>{{ commonInfo.acctNo1 }} - {{ commonInfo.acctNoSfx }}</span>
                </v-flex>
                <!-- TODO add Billing Account Name -->
                <v-flex xs4>
                  <v-subheader class="queryLabel">Insured Reference</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.insdRefNo">
                  <span>{{ commonInfo.insdRefNo }} - {{ commonInfo.insdName1 }}</span>
                </v-flex>
                <v-flex xs8 v-else>
                  <span>-</span>
                </v-flex>
                <v-flex xs4>
                  <v-subheader class="queryLabel">NRIC/Passport</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.icNo">
                  <span>{{ commonInfo.icNo }}</span>
                </v-flex>
                <v-flex xs8 v-else>
                  <span>-</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.riskGrpNo || commonInfo.riskGrpNo === 0">
                  <v-subheader class="queryLabel">Risk Group No.</v-subheader>
                </v-flex>
                <v-flex xs2 v-if="commonInfo.riskGrpNo || commonInfo.riskGrpNo === 0">
                  <span>{{ commonInfo.riskGrpNo }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.riskNo || commonInfo.riskNo === 0">
                  <v-subheader class="queryLabel">Risk No.</v-subheader>
                </v-flex>
                <v-flex xs2 v-if="commonInfo.riskNo || commonInfo.riskNo === 0">
                  <span>{{ commonInfo.riskNo }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.busCls">
                  <v-subheader class="queryLabel">Business Class</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.busCls">
                  <span>{{ commonInfo.busClsDesc }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.vehRegNo">
                  <v-subheader class="queryLabel">Vehicle No.</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.vehRegNo">
                  <span>{{ commonInfo.vehRegNo }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.vesNo">
                  <v-subheader class="queryLabel">Vessel No.</v-subheader>
                </v-flex>
                <v-flex xs8 v-if="commonInfo.vesNo">
                  <span>{{ commonInfo.vesNo }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap xs12> </v-layout>
              <v-layout row wrap xs12>
                <v-flex xs4 v-if="commonInfo.selectedClaimant">
                  <v-subheader class="queryLabel">Claimant No.</v-subheader>
                </v-flex>
                <v-flex xs2 v-if="commonInfo.selectedClaimant">
                  <span>{{ commonInfo.selectedClaimant.clmtNo }}</span>
                </v-flex>
                <v-flex xs4 v-if="commonInfo.selectedClmItem">
                  <v-subheader class="queryLabel">Claim Item No.</v-subheader>
                </v-flex>
                <v-flex xs2 v-if="commonInfo.selectedClmItem">
                  <span>{{ commonInfo.selectedClmItem.clmItem }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-expansion-panel-content>
        <div slot="header" class="body-2"></div>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap xs12>
              <v-flex xs4>
                <v-subheader class="queryLabel">Entered by</v-subheader>
              </v-flex>
              <v-flex xs8> {{ commonInfo.createdBy }} on {{ formatDate(commonInfo.createdDate) }} </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">Last Updated by</v-subheader>
              </v-flex>
              <v-flex xs8> {{ commonInfo.modifiedBy }} on {{ formatDate(commonInfo.modifiedDate) }} </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { claimStatus } from '@/const/claims'

export default {
  data() {
    return {
      panel: [0],
      labels: {
        mainDetail: 'Main Information',
        reserveInfo: 'Reserve Information'
      }
    }
  },
  computed: {
    claimDetail() {
      return this.$store.state.claims.claimDetail
    },
    currentStatusLabel() {
      if (claimStatus[this.claimDetail.commonInfo.statusCode]) {
        return claimStatus[this.claimDetail.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    commonInfo() {
      return this.claimDetail.commonInfo
    },
    claimIcon() {
      return 'mdi-cash-usd'
    }
  },
  methods: {
    formatStatusCode(data) {
      switch (data) {
        case 'O': {
          return 'green--text'
        }
        default: {
          return ''
        }
      }
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayDateTime2(date) {
      return formatDisplayDateTime2(date)
    },
    doSave() {
      // Emit saving event on global event bus
      // Each quote page should listen to this and do partial Submit and save
      this.$root.$emit('saveClaim')
    },
    async doVoid() {
      this.$root.$emit('void')
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  components: {},
  mixins: [MessageMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    reserveInfo: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@media (min-width: 1264px) {
  .quoteSideInfo {
    // Module specific override
    min-height: 425px;
  }
}
</style>
